export const enum LOCAL_STORAGE_KEYS {
	VIEWED_MIGRATION_INFO_DIALOG = "viewed_migration_info_dialog",
	USER_SEARCH_APPROXIMATE = "user_search_approximate",
	USER_SEARCH_ACTIVE_ONLY = "user_search_active_only",
	USER_SEARCH_NAME = "user_search_name",
	SKIP_NEW_LOGIN_WARNING = "skip_new_login_warning",
	EXT_ADMIN_CTRLS = "ext_admin_ctrls",
	SUBSCRIPTION_EXPIRY_DAYS = "subscription_expiry_days",
	USER_SEARCH_EXTRA_FIELDS = "user_search_extra_fields"
}
